"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonExerciseDto = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const swagger_1 = require("@nestjs/swagger");
const common_entity_dto_1 = require("./common-entity.dto");
const constants_1 = require("../constants");
const level_enum_1 = require("../enum/level.enum");
const vector_enum_1 = require("../enum/vector.enum");
const hinge_enum_1 = require("../enum/hinge.enum");
let CommonExerciseDto = class CommonExerciseDto extends common_entity_dto_1.CommonEntityDto {
    constructor() {
        super();
        this.availableToBeSelected = true;
    }
};
__decorate([
    swagger_1.ApiProperty({
        title: 'Title',
        description: 'The title of the exercise.',
        maxLength: constants_1.TEXT_MAX_LENGTH_NAME,
    }),
    class_validator_1.IsString(),
    class_validator_1.IsNotEmpty({ message: 'Title is required.' }),
    class_validator_1.MaxLength(constants_1.TEXT_MAX_LENGTH_NAME, {
        message: 'Title must not exceed the limit of 100 characters.',
    }),
    class_transformer_1.Expose(),
    __metadata("design:type", String)
], CommonExerciseDto.prototype, "title", void 0);
__decorate([
    swagger_1.ApiPropertyOptional({
        title: 'Video Url for the exercise',
        description: 'A video url related to the exercise.',
        maxLength: constants_1.TEXT_MAX_LENGTH_URL,
    }),
    class_validator_1.IsOptional(),
    class_validator_1.IsString(),
    class_validator_1.MaxLength(constants_1.TEXT_MAX_LENGTH_URL),
    class_transformer_1.Expose(),
    __metadata("design:type", String)
], CommonExerciseDto.prototype, "videoUrl", void 0);
__decorate([
    swagger_1.ApiPropertyOptional({
        title: 'Comments',
        description: 'A comment related to the exercise.',
        maxLength: constants_1.TEXT_MAX_LENGTH_DESCRIPTION,
    }),
    class_validator_1.IsOptional(),
    class_validator_1.IsString(),
    class_validator_1.MaxLength(constants_1.TEXT_MAX_LENGTH_DESCRIPTION, {
        message: 'Comments must not exceed the limit of $constraint1 characters.',
    }),
    class_transformer_1.Expose(),
    __metadata("design:type", String)
], CommonExerciseDto.prototype, "comments", void 0);
__decorate([
    swagger_1.ApiPropertyOptional({
        title: 'Available to be selected',
        description: 'flag to set it the available or not.',
        type: 'boolean',
    }),
    class_validator_1.IsBoolean(),
    class_transformer_1.Expose(),
    __metadata("design:type", Object)
], CommonExerciseDto.prototype, "availableToBeSelected", void 0);
__decorate([
    swagger_1.ApiPropertyOptional({
        title: 'Weight',
        description: 'A weight related to the exercise.',
        maxLength: constants_1.TEXT_MAX_LENGTH_SHORT,
    }),
    class_validator_1.IsOptional(),
    class_validator_1.IsString(),
    class_validator_1.MaxLength(constants_1.TEXT_MAX_LENGTH_SHORT, {
        message: 'Weight must not exceed the limit of $constraint1 characters.',
    }),
    class_transformer_1.Expose(),
    __metadata("design:type", String)
], CommonExerciseDto.prototype, "weight", void 0);
__decorate([
    swagger_1.ApiPropertyOptional({
        title: 'Set Count',
        description: 'A setCount related to the exercise.',
        maxLength: constants_1.NUMBER_MAX_TWO_DECIMALS,
    }),
    class_validator_1.IsOptional(),
    class_validator_1.Max(constants_1.NUMBER_MAX_TWO_DECIMALS, { message: 'Set Count must be less than 100.' }),
    class_transformer_1.Expose(),
    class_validator_1.IsNumber({}, {
        message: 'Invalid Set Count format. Please check if the line contains only numbers and try again.',
    }),
    class_transformer_1.Type(() => Number),
    __metadata("design:type", Number)
], CommonExerciseDto.prototype, "setCount", void 0);
__decorate([
    swagger_1.ApiPropertyOptional({
        title: 'Number or repetitions',
        description: 'A number of reps for the exercise.',
        maxLength: constants_1.NUMBER_MAX_TWO_DECIMALS,
    }),
    class_validator_1.IsOptional(),
    class_validator_1.Max(constants_1.NUMBER_MAX_TWO_DECIMALS, { message: 'Set Count must be less than 100.' }),
    class_transformer_1.Expose(),
    class_validator_1.IsNumber({}, {
        message: 'Invalid Rep Count format. Please check if the line contains only numbers and try again.',
    }),
    class_transformer_1.Type(() => Number),
    __metadata("design:type", Number)
], CommonExerciseDto.prototype, "repCount", void 0);
__decorate([
    swagger_1.ApiProperty({
        title: 'Rest Seconds',
        description: 'The seconds to rest between the reps of the exercise.',
        maxLength: constants_1.TEXT_REST_TIME_MAX_LENGTH_SHORT,
    }),
    class_validator_1.IsOptional(),
    class_validator_1.IsString(),
    class_transformer_1.Expose(),
    class_validator_1.MaxLength(constants_1.TEXT_REST_TIME_MAX_LENGTH_SHORT, {
        message: 'Rest Time must not exceed the limit of $constraint1 characters.',
    }),
    __metadata("design:type", String)
], CommonExerciseDto.prototype, "restSeconds", void 0);
__decorate([
    swagger_1.ApiProperty({
        title: 'Level',
        description: 'The Level for the exercise.',
        enum: level_enum_1.LevelEnum,
    }),
    class_transformer_1.Expose(),
    class_transformer_1.Transform(value => value === null || value === void 0 ? void 0 : value.toLowerCase()),
    class_validator_1.IsNotEmpty({ message: 'Level is required. Needs to be one of the following basic, intermediate or advanced' }),
    class_validator_1.IsEnum(level_enum_1.LevelEnum, {
        message: 'Invalid level. Please check if the line contains basic, intermediate or advanced, and try again.',
    }),
    __metadata("design:type", String)
], CommonExerciseDto.prototype, "level", void 0);
__decorate([
    swagger_1.ApiProperty({
        title: 'Vector',
        description: 'The Vector for the exercise needs to be one of the following [push, pull, static].',
        enum: vector_enum_1.VectorEnum,
    }),
    class_transformer_1.Expose(),
    class_transformer_1.Transform(value => value === null || value === void 0 ? void 0 : value.toLowerCase()),
    class_validator_1.IsNotEmpty({ message: 'Vector is required.' }),
    class_validator_1.IsEnum(vector_enum_1.VectorEnum, {
        message: 'Invalid Vector. Please check if the line contains push, pull or static, and try again.',
    }),
    __metadata("design:type", String)
], CommonExerciseDto.prototype, "vector", void 0);
__decorate([
    swagger_1.ApiProperty({
        title: 'Hinge',
        description: 'The Hinge for the exercise needs to be one of the following [shoulder, elbow, hip, knee].',
        enum: hinge_enum_1.HingeEnum,
    }),
    class_transformer_1.Expose(),
    class_transformer_1.Transform(value => value === null || value === void 0 ? void 0 : value.toLowerCase()),
    class_validator_1.IsNotEmpty({ message: 'Hinge is required.' }),
    class_validator_1.IsEnum(hinge_enum_1.HingeEnum, {
        message: 'Invalid Hinge. Please check if the line contains shoulder, elbow, hip, knee, and try again.',
    }),
    __metadata("design:type", String)
], CommonExerciseDto.prototype, "hinge", void 0);
__decorate([
    swagger_1.ApiProperty({
        title: 'Primary Muscle Group',
        format: 'uuid',
        description: 'Id of the primary Muscle Group for this exercise.',
    }),
    class_validator_1.IsUUID(),
    class_transformer_1.Expose(),
    __metadata("design:type", Object)
], CommonExerciseDto.prototype, "primaryMuscleGroupId", void 0);
__decorate([
    swagger_1.ApiProperty({
        title: 'Primary Muscle Group',
        format: 'uuid',
        description: 'Id of the primary Muscle Group for this exercise.',
    }),
    class_validator_1.IsUUID(),
    class_transformer_1.Expose(),
    __metadata("design:type", Object)
], CommonExerciseDto.prototype, "secondaryMuscleGroupId", void 0);
CommonExerciseDto = __decorate([
    class_transformer_1.Exclude(),
    __metadata("design:paramtypes", [])
], CommonExerciseDto);
exports.CommonExerciseDto = CommonExerciseDto;
//# sourceMappingURL=common-exercise.dto.js.map